import NewCustomer from './NewCustomer';

export default NewCustomer;
